/**
 * @generated SignedSource<<0b0434d9a6ce3d60836dcc6d5e54bef7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
export type useGwtUser_userTypeQuery$variables = Record<PropertyKey, never>;
export type useGwtUser_userTypeQuery$data = {
  readonly gwtUsers: {
    readonly nodes: ReadonlyArray<{
      readonly firstName: string;
      readonly lastName: string;
      readonly rowId: UUID;
    }>;
  } | null | undefined;
  readonly myUser: {
    readonly company: {
      readonly name: string;
    } | null | undefined;
    readonly emailBulk: boolean;
    readonly emailBulkTime: Date;
    readonly emailModuleNotifications: ReadonlyArray<string | null | undefined>;
    readonly emailOnAllAssignmentStatusChanges: boolean;
    readonly emailOnCommentAdded: boolean;
    readonly emailOnFeedbackProvided: boolean;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly lastName: string;
    readonly partnersonline: boolean;
    readonly programs: ReadonlyArray<ProgramType | null | undefined>;
    readonly rowId: UUID;
    readonly status: UserStatus;
    readonly userType: UserType;
  } | null | undefined;
};
export type useGwtUser_userTypeQuery = {
  response: useGwtUser_userTypeQuery$data;
  variables: useGwtUser_userTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnAllAssignmentStatusChanges",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailBulk",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailBulkTime",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailModuleNotifications",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnCommentAdded",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnFeedbackProvided",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programs",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnersonline",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "FIRST_NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useGwtUser_userTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GwtUser",
        "kind": "LinkedField",
        "name": "myUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v16/*: any*/),
        "concreteType": "GwtUsersConnection",
        "kind": "LinkedField",
        "name": "gwtUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GwtUser",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "gwtUsers(orderBy:\"FIRST_NAME_ASC\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useGwtUser_userTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GwtUser",
        "kind": "LinkedField",
        "name": "myUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v16/*: any*/),
        "concreteType": "GwtUsersConnection",
        "kind": "LinkedField",
        "name": "gwtUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GwtUser",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "gwtUsers(orderBy:\"FIRST_NAME_ASC\")"
      }
    ]
  },
  "params": {
    "cacheID": "78303d6e5a101ea236ddf42444141142",
    "id": null,
    "metadata": {},
    "name": "useGwtUser_userTypeQuery",
    "operationKind": "query",
    "text": "query useGwtUser_userTypeQuery {\n  myUser {\n    id\n    rowId\n    userType\n    emailOnAllAssignmentStatusChanges\n    emailBulk\n    emailBulkTime\n    emailModuleNotifications\n    emailOnCommentAdded\n    emailOnFeedbackProvided\n    status\n    fullName\n    firstName\n    lastName\n    programs\n    partnersonline\n    company {\n      name\n      id\n    }\n  }\n  gwtUsers(orderBy: FIRST_NAME_ASC) {\n    nodes {\n      rowId\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4a23480ab35e682511eb77994dd401d";

export default node;
